import React from "react";
import KombuchaBottle from "./KombuchaBottle";

const productConfigs = {
    original: {
        liquidColor: "#4CAF50",
        liquidColorLight: "#81C784",
        accentColor: "#2E7D32",
        label: "ORIGINAL",
    },
    "ginger-lemon": {
        liquidColor: "#FFC107",
        liquidColorLight: "#FFE082",
        accentColor: "#FF8F00",
        label: "GINGER LEMON",
    },
    "berry-blast": {
        liquidColor: "#7B1FA2",
        liquidColorLight: "#BA68C8",
        accentColor: "#E91E63",
        label: "BERRY BLAST",
    },
    "tropical-mango": {
        liquidColor: "#FF9800",
        liquidColorLight: "#FFCC80",
        accentColor: "#F57C00",
        label: "TROPICAL MANGO",
    },
    "lavender-honey": {
        liquidColor: "#9575CD",
        liquidColorLight: "#D1C4E9",
        accentColor: "#FFA000",
        label: "LAVENDER HONEY",
    },
    "mint-mojito": {
        liquidColor: "#00897B",
        liquidColorLight: "#80CBC4",
        accentColor: "#43A047",
        label: "MINT MOJITO",
    },
    "turmeric-golden": {
        liquidColor: "#F9A825",
        liquidColorLight: "#FDD835",
        accentColor: "#EF6C00",
        label: "TURMERIC GOLDEN",
    },
    "apple-cinnamon": {
        liquidColor: "#D84315",
        liquidColorLight: "#FF8A65",
        accentColor: "#BF360C",
        label: "APPLE CINNAMON",
    },
};

export const ProductImage = ({ productId, size = 250 }) => {
    const config = productConfigs[productId] || productConfigs.original;

    return (
        <KombuchaBottle
            liquidColor={config.liquidColor}
            liquidColorLight={config.liquidColorLight}
            accentColor={config.accentColor}
            label={config.label}
            size={size}
        />
    );
};

export const ProductThumbnail = ({ productId }) => {
    const config = productConfigs[productId] || productConfigs.original;

    return (
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id={`thumbGrad-${productId}`} x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor={config.liquidColorLight} />
                    <stop offset="100%" stopColor={config.liquidColor} />
                </linearGradient>
            </defs>

            {/* Background circle */}
            <circle cx="60" cy="60" r="55" fill="rgba(255,255,255,0.1)" />

            {/* Simple bottle silhouette */}
            <g transform="translate(35, 15)">
                {/* Bottle neck */}
                <rect x="15" y="0" width="20" height="12" rx="2" fill="#2D2D2D"/>

                {/* Bottle body */}
                <path
                    d="M10 20 Q5 25 5 35 L5 80 Q5 88 15 88 L35 88 Q45 88 45 80 L45 35 Q45 25 40 20 L35 15 L15 15 Z"
                    fill={`url(#thumbGrad-${productId})`}
                    stroke="rgba(255,255,255,0.3)"
                    strokeWidth="1"
                />

                {/* Label */}
                <rect x="8" y="45" width="34" height="25" rx="2" fill="rgba(255,255,255,0.9)"/>
                <rect x="8" y="45" width="34" height="8" fill={config.accentColor}/>

                {/* Bubbles */}
                <circle cx="15" cy="75" r="2" fill="rgba(255,255,255,0.5)">
                    <animate attributeName="cy" values="75;55;75" dur="2s" repeatCount="indefinite"/>
                </circle>
                <circle cx="30" cy="70" r="1.5" fill="rgba(255,255,255,0.4)">
                    <animate attributeName="cy" values="70;50;70" dur="2.5s" repeatCount="indefinite"/>
                </circle>
            </g>
        </svg>
    );
};

export { KombuchaBottle };
export default ProductImage;
